<!-- Back Arrow -->
<button class="back-button" (click)="goBack()">←</button>

<div class="confirmation-overlay" *ngIf="showPublishDialog" [@overlayAnimation]>
  <div class="reminder-dialog" [@dialogAnimation]="dialogState">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi" 
           [class.pi-check-circle]="publishState === 'success'"
           [class.pi-spinner]="publishState === 'processing'"
           [class.animate-spin]="publishState === 'processing'"
           [class.text-green-600]="publishState !== 'success'"
           [class.text-green-500]="publishState === 'success'"
           [@iconAnimation]="publishState"></i>
           <h2 class="dialog-title">
            {{ 
              publishState === 'processing' ? 'Publishing...' : 
              publishState === 'success' ? 'Published!' : 
              errorMessage ? errorMessage : 'Confirm Publish' 
            }}
          </h2>
          
      </div>
    </div>
    
    <div class="dialog-content">
      <div class="content-wrapper">
        <p class="confirmation-text">
          <span *ngIf="publishState === 'success'">Item published successfully!</span>
          <span *ngIf="publishState !== 'success'">
            Are you sure you want to publish this item? Once published, You couldn't edit it again.
          </span>
        </p>
      </div>
    </div>

    <div class="dialog-actions" *ngIf="publishState !== 'success'">
      <button 
        pButton 
        label="Cancel" 
        class="p-button-text" 
        (click)="cancelPublish()"
        [disabled]="publishState === 'processing'"
        [@buttonAnimation]></button>
      <button 
        pButton 
        label="{{ publishState === 'processing' ? 'Processing...' : 'Publish' }}" 
        class="p-button-success" 
        (click)="confirmPublish()"
        [disabled]="publishState === 'processing'">
        <i class="pi pi-spinner animate-spin mr-2" *ngIf="publishState === 'processing'"></i>
      </button>
    </div>
  </div>
</div>

<div class="news-article">
  <!-- Hero Banner -->
  <!-- Article Header -->
  <div class="news-card-wrapper">
  <!-- Article Header -->
  <div class="news-card-wrapper">
    <div class="news-header-section" @fadeIn>
      <ng-container *ngIf="newsData?.details; else headerSkeleton">
        <h1 class="main-heading">{{ newsData?.details?.title }}</h1>
        <div class="meta-badge">
          {{ newsData?.details?.launchDate | date : "longDate" }}
        </div>
      </ng-container>
      <ng-template #headerSkeleton>
        <p-skeleton width="80%" height="2.5rem" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="40%" height="1.5rem"></p-skeleton>
      </ng-template>
    </div>
  </div>
 
  
    <!-- <div class="featured-image-container">
      <img [src]="newsData?.details?.featuredImage || 'default-image.jpg'" 
           alt="Article featured image"
           class="featured-visual">
    </div> -->
  
    <!-- <div class="content-section">
      <div class="news-content-body" [innerHTML]="newsData?.details?.content"></div>
    </div> -->
  </div>
  <div class="hero-banner">
    <ng-container *ngIf="newsData?.bannerImage; else bannerSkeleton">
      <img [src]="newsData?.bannerImage" alt="Banner" class="banner-image" />
      <div class="banner-overlay"></div>
    </ng-container>
    <ng-template #bannerSkeleton>
      <p-skeleton [style]="{ height: '400px' }" styleClass="mb-2"></p-skeleton>
    </ng-template>
  </div>

  

  <!-- Content Section -->
  <div class="article-content">
    <!-- Short Description Skeleton -->
    <div class="short-description-container">
      <ng-container *ngIf="newsData?.details?.shortDescription; else shortDescSkeleton">
        <h1 class="article-shortDescription">
          {{ newsData?.details?.shortDescription }}
        </h1>
      </ng-container>
      <ng-template #shortDescSkeleton>
        <p-skeleton width="100%" height="4rem" styleClass="mb-2"></p-skeleton>
      </ng-template>
    </div>

    <!-- Main Content Skeleton -->
    <ng-container *ngIf="sanitizedContent; else contentSkeleton">
      <div class="content-html" [innerHTML]="sanitizedContent"></div>
    </ng-container>
    <ng-template #contentSkeleton>
      <div class="content-skeletons">
        <p-skeleton width="100%" height="1rem" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="100%" height="1rem" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="70%" height="1rem" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="90%" height="1rem" styleClass="mb-2"></p-skeleton>
      </div>
    </ng-template>
  </div>

  <!-- Carousel Skeleton -->
  <div class="custom-carousel" *ngIf="newsData?.newsImages?.length">
    <div class="carousel-container">
      <div
        class="carousel-track"
        [style.transform]="'translateX(-' + activeIndex * 100 + '%)'"
      >
        <div
          class="carousel-slide"
          *ngFor="let image of newsData?.newsImages; let i = index"
        >
          <img [src]="image.url" alt="Media {{ i + 1 }}" />
          <!-- <div class="slide-caption">Media {{i+1}}</div> -->
        </div>
      </div>
    </div>

    <!-- Navigation Arrows -->
    <button class="carousel-prev" (click)="prevSlide()">❮</button>
    <button class="carousel-next" (click)="nextSlide()">❯</button>

    <!-- Indicators -->
    <div class="carousel-indicators">
      <span
        *ngFor="let image of newsData?.newsImages; let i = index"
        [class.active]="i === activeIndex"
        (click)="setActiveIndex(i)"
      ></span>
    </div>
  </div>

</div>
<div @fadeIn  *ngIf="!published">
  <button 
    class="publish-button"
    [@floatAnimation]="buttonState"
    [@clickAnimation]="clickState"
    (click)="publish()"
  >
    <span class="button-content">
      <i class="material-icons">publish</i>
      <span class="button-text">Publish</span>
    </span>
  </button>
</div>
